<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['patient_triage']==1">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <form @submit.prevent="AddPatient">
              <div class="row">
                <div class="col-lg-4">
                  <div class="form-group mb-2">
                    <label>Patient's Name</label>
                    <multiselect
                      v-model="patient"
                      @input="FilterPatient"
                      :options="patients"
                      :custom-label="customLabel"
                      label="name"
                      :class="{ 'is-invalid-field': hasError('patient') }"
                    ></multiselect>
                    <small v-if="hasError('patient')" class="text-danger">{{ fieldError('patient') }}</small>
                  </div>
                  <div class="form-group mb-2">
                    <label>Triage Date</label>
                    <input v-model="triagedate" type="date" class="form-control" :class="{ 'is-invalid': hasError('triagedate') }" />
                    <small v-if="hasError('triagedate')" class="text-danger">{{ fieldError('triagedate') }}</small>
                  </div>
                  <div class="form-group mb-2">
                    <label>Telephone</label>
                    <b-input-group :prepend="userData.countryCode"><input v-model="telephone" readonly type="text" class="form-control"/></b-input-group>
                  </div>
                  <div class="form-group mb-2">
                    <label>Gender</label>
                    <input v-model="gender" readonly type="text" class="form-control" />
                  </div>
                  <div class="form-group mb-2">
                    <label>Address</label>
                    <input v-model="address" readonly type="text" class="form-control" />
                  </div>
                </div>

                <div class="col-lg-4">
                  <div class="form-group mb-2">
                    <b-form-group label="Temperature ( C )" description="Patient's Temperature">
                      <input v-model="temperature" type="text" class="form-control" :class="{ 'is-invalid': hasError('temperature') }" />
                      <small v-if="hasError('temperature')" class="text-danger">{{ fieldError('temperature') }}</small>
                    </b-form-group>
                  </div>
                  <div class="form-group mb-2">
                    <b-form-group label="Weight (Kgs)" description="Patient's Weight">
                      <input v-model="weight" type="text" class="form-control" :class="{ 'is-invalid': hasError('weight') }" />
                      <small v-if="hasError('weight')" class="text-danger">{{ fieldError('weight') }}</small>
                    </b-form-group>
                  </div>
                  <div class="form-group mb-2">
                    <b-form-group label="Height (cm)" description="Patient's Height">
                      <input v-model="height" type="text" class="form-control" :class="{ 'is-invalid': hasError('height') }" />
                      <small v-if="hasError('height')" class="text-danger">{{ fieldError('height') }}</small>
                    </b-form-group>
                  </div>
                  <div class="form-group mb-2">
                    <b-form-group label="MUAC (cm)" description="Mid Upper Arm Circumference">
                      <input v-model="muac" type="text" class="form-control" :class="{ 'is-invalid': hasError('muac') }"/>
                      <small v-if="hasError('muac')" class="text-danger">{{ fieldError('muac') }}</small>
                    </b-form-group>
                  </div>
                </div>

                <div class="col-lg-4">
                  <div class="form-group mb-2">
                    <b-form-group label="Blood Pressure(mmHg)" description="Blood Pressure">
                      <input v-model="bloodpressure" type="text" class="form-control" :class="{ 'is-invalid': hasError('bloodpressure') }" />
                      <small v-if="hasError('bloodpressure')" class="text-danger">{{ fieldError('bloodpressure') }}</small>
                    </b-form-group>
                  </div>
                  <div class="form-group mb-2">
                    <b-form-group label="Pulse (b/min)" description="Heart Rate and Pulse">
                      <input v-model="pulse" type="text" class="form-control" :class="{ 'is-invalid': hasError('pulse') }" />
                      <small v-if="hasError('pulse')" class="text-danger">{{ fieldError('pulse') }}</small>
                    </b-form-group>
                  </div>
                  <div class="form-group mb-2">
                    <b-form-group label="Oxygen Rate (%)" description="SpO2">
                      <input v-model="oxygenrate" type="text" class="form-control" :class="{ 'is-invalid': hasError('oxygenrate') }" />
                      <small v-if="hasError('oxygenrate')" class="text-danger">{{ fieldError('oxygenrate') }}</small>
                    </b-form-group>
                  </div>
                  <div class="form-group mb-2">
                    <label>Turn around time</label>
                    <b-form-select class="form-control" v-model="turnaroundtime" :class="{ 'is-invalid': hasError('turnaroundtime') }">
                      <option value="1">Waiting</option>
                      <option value="2">Emergency</option>
                    </b-form-select>
                    <small v-if="hasError('turnaroundtime')" class="text-danger">{{ fieldError('turnaroundtime') }}</small>
                  </div>
                  <div class="form-group"><br>
                    <b-button type="submit" class="btn w-100" variant="primary" :disabled="submitting">
                      <b-spinner v-if="submitting" small class="align-middle me-1"></b-spinner>
                      <i v-else class="fas fa-check-circle"></i>
                      {{ submitting ? 'Submitting...' : 'Submit' }}
                    </b-button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to Patient`s Triage</span></center>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Multiselect from "vue-multiselect";
import appConfig from "@/app.config";
import { patientMethods, patientComputed } from "@/state/helpers";

export default {
  page: {
    title: "Patient Triage",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,
    Multiselect,
    PageHeader,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Patient Triage",
      items: [{text: "Dashboard",href: "/"},{text: "Patients",active: true}],
      services:[],
      patient: "",
      telephone:'',
      gender:'',
      address:'',
      triagedate: new Date().toLocaleDateString('fr-CA'),
      weight: "",
      muac: "",
      height: "",
      bloodpressure: "",
      temperature: "",
      pulse: "",
      oxygenrate: "",
      turnaroundtime:'1',
      submitting: false,
      errors: {},
    };
  },
  methods: {
    ...patientMethods,
    customLabel({ patient_id, name }) {
      return `${name} - ${patient_id}`
    },
    hasError(field) {
      return !!this.errors[field];
    },
    fieldError(field) {
      const value = this.errors[field];
      return Array.isArray(value) ? value[0] : value;
    },
    clearFieldError(field) {
      if (this.errors[field]) {
        const next = { ...this.errors };
        delete next[field];
        this.errors = next;
      }
    },
    resetForm() {
      this.patient = "";
      this.telephone = "";
      this.gender = "";
      this.address = "";
      this.triagedate = new Date().toLocaleDateString('fr-CA');
      this.weight = "";
      this.muac = "";
      this.height = "";
      this.bloodpressure = "";
      this.temperature = "";
      this.pulse = "";
      this.oxygenrate = "";
      this.turnaroundtime = '1';
      this.errors = {};
    },
    async FilterPatient() {
      this.clearFieldError('patient');
      let url = `/findpatient/${this.patient.patient_id}`;
      await axios.get(url).then((response) => {
        if (response.data.patients) {
          this.telephone = response.data.patients[0].telephone;
          this.address = response.data.patients[0].address;
          this.gender = response.data.patients[0].gender;
        }
      });
    },
    async AddPatient() {
      this.errors = {};
      if (!this.patient || !this.patient.patient_id) {
        this.errors = { patient: ['Select a patient.'] };
        this.$toast.error('Select a patient before submitting.');
        return;
      }
      let formData = new FormData();
      formData.append("patient", this.patient.patient_id);
      formData.append("triagedate", this.triagedate);
      formData.append("temperature", this.temperature);
      formData.append("weight", this.weight);
      formData.append("height", this.height);
      formData.append("muac", this.muac);
      formData.append("bloodpressure", this.bloodpressure);
      formData.append("pulse", this.pulse);
      formData.append("oxygenrate", this.oxygenrate);
      formData.append("turnaroundtime", this.turnaroundtime);
      let url = "/addtraiage";
      this.submitting = true;
      try {
        const response = await axios.post(url, formData);
        if (response.status == 200) {
          this.fetchPatients();
          this.resetForm();
          this.$toast.success(response.data.message);
        }
      } catch (error) {
        if (error.response?.status === 422) {
          this.errors = error.response.data.errors || {};
          this.$toast.error(error.response.data.message || 'Please correct the highlighted fields.');
        } else {
          this.$toast.error(error.response?.data?.message || 'Failed to save patient triage.');
        }
      } finally {
        this.submitting = false;
      }
    },
  },
  computed: {
    ...patientComputed,
  },
  mounted() {
    this.fetchPatients();
  },
};
</script>

<style scoped>
.is-invalid-field :deep(.multiselect__tags) {
  border-color: #dc3545;
}
</style>
